import { render, staticRenderFns } from "./SWPTax.vue?vue&type=template&id=2e41a840&scoped=true"
import script from "./SWPTax.vue?vue&type=script&lang=js"
export * from "./SWPTax.vue?vue&type=script&lang=js"
import style0 from "./SWPTax.vue?vue&type=style&index=0&id=2e41a840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e41a840",
  null
  
)

export default component.exports